<lb-responsive-layout [stickyLeft]="true" [autoCloseSlideout]="true" [slideoutAriaLabel]="'Conversation list'">
	<ng-container left-content>
		<lrnr-conversation-list
			[conversations]="threads()"
			[activeConversationId]="activeThread()?.id ?? null"
			(conversationSelected)="selectThread($event)"
			(newConversationRequested)="createNewThread()"
		/>
	</ng-container>

	<ng-container right-content>
		@if (activeThread()) {
			<lb-chat-message-area
				[conversation]="activeThread()!"
				[messages]="messages()"
				[loading]="loading()"
				[userInitials]="userInitials()"
				[showMenuToggle]="true"
				(messageSent)="sendMessage($event)"
				(menuToggled)="toggleMobileMenu()"
			/>
		} @else {
			<div class="empty-state">
				<md-icon icon="untitled-ui/communication/message-chat-circle"></md-icon>
				<md-header size="sm">Select a conversation</md-header>
				<span>Choose a conversation from the sidebar to start chatting</span>
			</div>
		}
	</ng-container>
</lb-responsive-layout>
